<template lang="html">
  <div>
    <v-card>
      <v-card-title>
        {{ thema ? thema : "Alle indicatoren" }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Zoek"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-card-title>
      <div class="normalization-selection">
        <v-radio-group v-model="normalization" row>
          <v-radio label="Absoluut aantal" value="none"> </v-radio>
          <v-radio label="Aantal per inwoner" value="perInhabitant"> </v-radio>
          <v-radio label="Aantal per 1000 inwoners" value="per1000"> </v-radio>
        </v-radio-group>
      </div>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        show-expand
        item-key="indicatorId"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="detail-title">Beschrijving</div>
            <div class="detail-content">
              {{ item.beschrijving }}
            </div>
            <div class="detail-title">Analyse</div>
            <div class="detail-content">
              {{ item.analyse }}
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <div class="download-button">
      <v-btn color="primary" @click="exportForExcel()">
        Bewaar data als Excel bestand
      </v-btn>
    </div>
  </div>
</template>

<script>
//import { sum } from "d3-array";
import * as XLSX from "xlsx"; //Copyright (C) 2012-present   SheetJS LLC
export default {
  data: () => ({
    search: "",
    normalization: "none" //"none" or "perInhabitant"
  }),
  computed: {
    data_deelregios() {
      return this.$store.getters.data_deelregios;
    },
    pijler() {
      return this.$store.getters.pijler;
    },
    thema() {
      return this.$store.getters.thema;
    },
    indicator() {
      return this.$store.getters.indicator;
    },
    indicators() {
      return this.$store.getters.indicators;
    },
    filteredIndicators() {
      //filter on selected pijler and thema (if any)
      //sort alphabetically on variable name. TODO: Put selected indicator (if any) on top.
      return this.indicators
        .filter(
          i =>
            (!this.pijler || i.pijler == this.pijler) &&
            (!this.thema || i.thema == this.thema)
        )
        .sort((i1, i2) => {
          if (i1.thema < i2.thema) return -1;
          if (i1.thema > i2.thema) return 1;
          return 0;
        });
    },
    items() {
      let items = [];
      if (this.data_deelregios) {
        this.filteredIndicators.forEach(indicator => {
          let item = {
            indicatorId: indicator.variabele,
            indicatorOmschrijving: indicator.omschrijving,
            beschrijving: indicator.beschrijving,
            analyse: indicator.analyse,
            bron: indicator.bron
          };
          let totalNrInhabitantsForIndicator = 0;
          let totalValueForIndicator = 0;
          for (const [regio, values] of Object.entries(this.data_deelregios)) {
            const value = parseFloat(values[indicator.variabele]);
            const nrInhabitants = parseFloat(
              values[indicator["veld aantal inwoners"]]
            );
            item[regio] = this.getValueLabel(indicator, value, nrInhabitants);
            totalNrInhabitantsForIndicator += nrInhabitants;
            totalValueForIndicator += value;
          }
          item["MRA Totaal"] = this.getValueLabel(
            indicator,
            totalValueForIndicator,
            totalNrInhabitantsForIndicator
          );
          items.push(item);
        });
      }
      return items;
    },
    headers() {
      if (!this.data_deelregios) return [];
      const deelregios = Object.keys(this.data_deelregios).concat("MRA Totaal");
      return [
        { text: "Indicator", value: "indicatorOmschrijving" },
        ...deelregios.map(d => ({ text: d, value: d, sortable: false })),
        { text: "Toelichting", value: "data-table-expand" }
      ];
    }
  },
  methods: {
    getValueLabel(indicator, value, nrInhabitants) {
      if (isNaN(value)) return "onbekend";
      if (value == 0) return value;
      if (this.normalization == "perInhabitant") {
        const fraction = value / nrInhabitants;
        if (indicator["in euro"] != "") {
          return "€ " + Math.round(100 * fraction) / 100 + " per inwoner";
        } else if (fraction > 0.1) {
          return Math.round(10 * fraction) / 10 + " per inwoner";
        } else {
          return "1 op " + Math.round(1 / fraction) + " inwoners";
        }
      } else if (this.normalization == "per1000") {
        return Math.round((100000 * value) / nrInhabitants) / 100;
      } else {
        return Math.round(value);
      }
    },
    exportForExcel() {
      let table = [];
      //get items as nested list
      const columns = [
        { id: "indicatorId", label: "Variabele" },
        { id: "indicatorOmschrijving", label: "Omschrijving" },
        { id: "Almere-Lelystad", label: "Almere-Lelystad" },
        { id: "Amstelland-Meerlanden", label: "Amstelland-Meerlanden" },
        { id: "Amsterdam", label: "Amsterdam" },
        { id: "Gooi en Vechtstreek", label: "Gooi en Vechtstreek" },
        { id: "IJmond", label: "IJmond" },
        { id: "Zaanstreek-Waterland", label: "Zaanstreek-Waterland" },
        { id: "Zuid-Kennemerland", label: "Zuid-Kennemerland" }
      ];
      table.push(columns.map(c => c.label));
      //add one row per item
      this.items.forEach(item => {
        let row = columns.map(c => item[c.id]);
        table.push(row);
      });
      const ws = XLSX.utils.aoa_to_sheet(table);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "MRA Cultuurmonitor");
      /* generate file and send to client */
      const fileName = `${this.thema ? this.thema : "Alle indicatoren"}.xlsx`;
      XLSX.writeFile(wb, fileName);
    }
  }
};
</script>

<style lang="css" scoped>
.download-button {
  text-align: center;
  margin-top: 10px;
}
.normalization-selection {
  margin-left: 30px;
}
.detail-title {
  margin-top: 10px;
  font-weight: bold;
}
.detail-content {
  padding: 10px;
}
</style>
